// ----------------------------------------------------------------------

export default function Dialog(theme) {
  return {
    MuiDialog: {
      styleOverrides: {
        paper: {
          // Apply max-width constraint for ultrawide screens
          // This constrains dialogs to 1500px max on xl+ screens
          // MUI's built-in maxWidth (sm, md, lg) will still work for smaller sizes
          // For fullWidth or maxWidth="xl", this will prevent overly wide dialogs
          [theme.breakpoints.up('xl')]: {
            maxWidth: '1500px',
          },
        },
      },
    },
  };
}

